import { useState  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { axios, errorResponse } from '../../helpers'
import { loginData, logout } from '../../stores/auth';

const UsePost = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dataLogin = useSelector(loginData);
    const [isLoading,setIsLoading] = useState(false)        
    const [error,setError] = useState('')
    const [isSuccess,setIsSuccess] = useState(false)

    const handlePost = async params => {
        setIsLoading(true)
        try {
            const response = await axios.post(params.url,params.form, {
                headers: { Authorization: `Bearer ${dataLogin.data.token }` },
            });
            if(response.data.status){
                setIsSuccess(true)
                swal("Berhasil",response.data.message, "success",{
                    button : 'Tutup'
                }).then(() => {
                    setError('')
                    if(params.navigation){
                        navigate(params.navigation,{replace : true})
                    }else{
                        window.location.reload();
                    }
                });                
            }else{
                swal('Error',response.data.message,'error')
                setIsSuccess(false)
                setError(response.data.message)
            }
        } catch (err) {
            if(errorResponse(err) == 'jwt expired'){
                dispatch(logout())
            }else{
                setError(errorResponse(err))
                setIsSuccess(false)
                swal('Error',errorResponse(err),'error')
            }     
        }  finally{
            setIsLoading(false)
        }        
    }

    return {
        isLoading,
        error,
        isSuccess,
        navigate,
        handlePost,
    }
}

export default UsePost